/* @flow */
import React from 'react';

import type { TableProps } from './types';

let baseStyle = {
  color: '#222',
  backgroundColor: '#fff',
  tableLayout: 'auto',
  width: '100%',
  borderSpacing: '0px'
};

function Table({children, style, customDataTestID}: TableProps): React.Element {
  return (
    <table data-testid={customDataTestID} style={{...baseStyle, ...style}}>
    {children}
    </table>
  );
}

export default Table;
